import * as React from "react";
import { render } from "react-dom";
import { IntlProvider, addLocaleData } from "react-intl";
import * as nb from "react-intl/locale-data/nb";
import * as en from "react-intl/locale-data/en";
import { Provider, connect } from "react-redux";
import { compose, applyMiddleware, createStore, combineReducers } from "redux";
import thunk from "redux-thunk";
import "./gtm";
import initializeSentry from "./initializeSentry";
import "intl";
import "intl/locale-data/jsonp/en.js";
import "intl/locale-data/jsonp/nb.js";
import "promise/polyfill";
import "whatwg-fetch";

import { injectGlobals } from "styles/styles";
import "normalize.css";

import App from "./containers/App";
import api from "./helpers/middleware/api";
import stores, { ApplicationState } from "stores";

initializeSentry();
addLocaleData([...nb, ...en]);
injectGlobals();

const finalCreateStore = compose(applyMiddleware(thunk, api))(createStore);
const store = finalCreateStore(
  combineReducers<ApplicationState>({ ...stores })
);

interface IProps {
  locale: string;
  messages: { [key: string]: string };
}

const Application: React.FunctionComponent<IProps> = ({ locale, messages }) => (
  <IntlProvider locale={locale} messages={messages} key={locale}>
    <App />
  </IntlProvider>
);

const IntlProvidedApplication = connect((state: ApplicationState) => ({
  locale: state.i18n.locale,
  messages: state.i18n.messages
}))(Application);

render(
  <Provider store={store}>
    <IntlProvidedApplication />
  </Provider>,
  document.getElementById("root")
);
